import { useEffect, useState } from 'react';
import { useStore } from '../../../store/useStore';

/*
 * Colores de las gráficas.
 *
 * Recharts pinta SVG con atributos (`fill`, `stroke`) y un atributo SVG no resuelve var(--token),
 * así que los tokens de la interfaz se leen ya calculados del documento y se vuelven a leer al
 * cambiar de tema: las etiquetas de los ejes se leen igual en claro y en oscuro.
 */

// Tonos que acompañan al color del tema (medios: se ven bien sobre blanco y sobre el panel oscuro)
const PALETA = ['#4d7cc9', '#e0803a', '#2f9170', '#cf5a67', '#9c6ac8', '#c4a21f', '#3aa7b8', '#7f8497', '#b8568f', '#5c9a3a', '#6f5fd0', '#d06a3c'];

const cercano = (a, b) => {
  const p = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
  try {
    const [r1, g1, b1] = p(a);
    const [r2, g2, b2] = p(b);
    return Math.abs(r1 - r2) + Math.abs(g1 - g2) + Math.abs(b1 - b2) < 60;
  } catch {
    return false;
  }
};

/** Paleta categórica: el color del tema primero y luego los complementarios que no se le parezcan. */
export function paletaDe(colorTema) {
  const base = /^#[0-9a-f]{6}$/i.test(colorTema || '') ? colorTema : '#673ab7';
  return [base, ...PALETA.filter((c) => !cercano(c, base))];
}

function leer() {
  const css = getComputedStyle(document.documentElement);
  const v = (n, d) => (css.getPropertyValue(n) || '').trim() || d;
  return {
    texto: v('--text', '#1a1b22'),
    texto2: v('--text-2', '#575b6b'),
    texto3: v('--text-3', '#8d92a4'),
    linea: v('--line', '#e6e8f1'),
    linea2: v('--line-2', '#d6d9e6'),
    panel: v('--panel-2', '#ffffff'),
    hover: v('--hover', '#f0f1f8'),
  };
}

export function useColoresGrafica() {
  const tema = useStore((s) => s.theme);
  const [colores, setColores] = useState(leer);
  useEffect(() => {
    // La clase `dark` de <html> cambia en el mismo tick que el store: se lee en el siguiente frame
    const id = requestAnimationFrame(() => setColores(leer()));
    return () => cancelAnimationFrame(id);
  }, [tema]);
  return colores;
}

/** Estilo del tooltip de recharts con los tokens del tema. */
export const estiloTooltip = (c) => ({
  contentStyle: {
    background: c.panel,
    border: `1px solid ${c.linea2}`,
    borderRadius: 10,
    color: c.texto,
    fontSize: 12,
    boxShadow: '0 8px 24px rgba(0,0,0,.12)',
  },
  labelStyle: { color: c.texto, fontWeight: 600 },
  itemStyle: { color: c.texto2 },
  cursor: { fill: c.hover },
});

export const porcentaje = (n, total) => (total ? `${Math.round((n / total) * 1000) / 10}%` : '0%');
